import { render } from "./roles.vue?vue&type=template&id=11cd4ac3"
import script from "./roles.vue?vue&type=script&lang=ts"
export * from "./roles.vue?vue&type=script&lang=ts"
script.render = render

export default script